export const topicContentCssPath = '.topic-content';
export const topicFormCssPath = '.topic-form';
export const topicFormTitleCssPath = '.topic-form-title';
export const topicFormIdCssPath = '.form-topic-id';
export const topicFormInputKeyCssPath = '.form-topic-key';
export const topicFormSaveBtnCssPath = '.form-save-topic-btn';
export const topicFormCancelBtnCssPath = '.form-cancel-topic-btn';
export const topicFormEmailChannelCssPath = '.form-topic-email-channel';
export const topicFormSMSChannelCssPath = '.form-topic-sms-channel';
export const behaviorOpenFormTopic = '.behavior-open-form-topic';
export const topicsTable = '.topics-table';
